import { Box, Grid } from '@material-ui/core';
import { PlusIconTwoTone, Typography } from '@room-match/shared-ui-components';
import Stepper from 'components/Stepper/Stepper';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { COLORS } from 'shared/constants/COLORS';
import { ROUTES } from 'shared/constants/ROUTES';
import { ITalentMembersResponse } from 'shared/interfaces/IProfile';
import { ls } from 'shared/utils/ls';
import { MemberImage, useStyles } from './AddMembers.styles';

type Props = {
  members?: ITalentMembersResponse['data']['talents'];
};

const AddMembers: React.FC<Props> = ({ members }) => {
  const classes = useStyles();
  const [idSelected, setidSelected] = useState('');
  const { getLS } = ls();
  const option = getLS('option');
  const history = useHistory();
  const addMember = () => {
    history.push(ROUTES.MINOR_MEMBER_INFO);
  };

  return (
    <Box component="div" className={classes.root}>
      <Grid item className={classes.header}>
        <Typography fontSize={24} style={{ marginBottom: 20 }}>
          {option
            ? option === 'check-in'
              ? 'Select a profile below to Check-in'
              : 'Select a profile below to submit Self-tape'
            : 'Add Family / Group Members'}
        </Typography>
        <div style={{ maxWidth: 350, alignSelf: 'center', width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Stepper steps={4} active={members?.length ? 3 : 2} />
        </div>
      </Grid>
      <Box style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {members ? (
          members?.map((m) => (
            <Box
              onClick={() => setidSelected(m.id)}
              className={classes.form}
              key={m.id}
              style={{
                borderRadius: 8,
                cursor: 'pointer',
                border: `solid 2px ${idSelected === m.id || members.length === 1 ? COLORS.PRIMARY : 'transparent'}`,
                padding: 15,
              }}
            >
              {m.picture ? (
                <MemberImage src={`${m.picture}/224x0`} />
              ) : (
                <Box component="div" className={classes.boxContainer} style={{ backgroundImage: m.picture }}>
                  {/* <PlusIconTwoTone className={classes.icon} /> */}
                </Box>
              )}

              <Typography fontSize={15}>
                {m.first_name} {m.last_name}
              </Typography>
            </Box>
          ))
        ) : (
          <></>
        )}
        <Grid item className={classes.form}>
          <Box component="div" className={classes.boxContainer} onClick={addMember}>
            <PlusIconTwoTone className={classes.icon} />
            <Typography fontSize={15}>Add New Member</Typography>
          </Box>
        </Grid>
      </Box>
    </Box>
  );
};

export default AddMembers;
